import { replace } from 'connected-react-router';
import { blogs_api_popular_feed_all_get_url } from 'mk/urls/functions';
import {
    blogsPopularFeedFetchApi,
    BlogsPopularFeedFetchNormalizedResponse,
    BlogsPopularFeedFetchTriggerAction,
    BLOGS_POPULAR_FEED_FETCH_TRIGGER,
} from 'mk2/apps/blogs/containers/BlogsPopularFeed/BlogsPopularFeed.actions';
import { BlogFeedItemEntity, BlogFeedItemSchema } from 'mk2/apps/blogs/schemas';
import { ComplaintEntity, ComplaintSchema } from 'mk2/containers/Complaint/Complaint.schemas';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('blogs/BlogsPopularFeed.sagas');

interface ApiResponseFetchBlogsPopularFeed {
    body: {
        feedItems: BlogFeedItemEntity[];
        hasMore: boolean;
        complaints: ComplaintEntity[];
    };
}

function* fetchBlogsPopularFeed({ after, xhr }: BlogsPopularFeedFetchTriggerAction & XHRAction) {
    yield put(blogsPopularFeedFetchApi.request(after));

    try {
        const response: ApiResponseFetchBlogsPopularFeed = yield call(
            () => xhr.get(blogs_api_popular_feed_all_get_url(), {after}),
        );

        const normalizedResponse: BlogsPopularFeedFetchNormalizedResponse = normalize({
            complaints: response.body.complaints,
            feedItems: response.body.feedItems,
        }, {
            complaints: [ComplaintSchema],
            feedItems: [BlogFeedItemSchema],
        });

        yield put(blogsPopularFeedFetchApi.success(
            after,
            response.body.hasMore,
            normalizedResponse,
        ));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(blogsPopularFeedFetchApi.failure(after, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(BLOGS_POPULAR_FEED_FETCH_TRIGGER, fetchBlogsPopularFeed),
    ]);
}
